import { render } from "./AttachRemovePlanOpportunityComponent.vue?vue&type=template&id=2ed03924"
import script from "./AttachRemovePlanOpportunityComponent.vue?vue&type=script&lang=js"
export * from "./AttachRemovePlanOpportunityComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__